export const upcomingData = [
  {
    bookingCategory: "oneWay",
    bookingType: "upcoming",
    fareLocked: true
  },
  {
    bookingCategory: "oneWay",
    bookingType: "upcoming",
    fareLocked: false
  },
  {
    bookingCategory: "roundTrip",
    bookingType: "upcoming",
    fareLocked: false
  },
  {
    bookingCategory: "multiCity",
    bookingType: "upcoming",
    fareLocked: false
  }
];

export const pastData = [
  {
    bookingCategory: "oneWay",
    bookingType: "past",
    fareLocked: true
  },
  {
    bookingCategory: "roundTrip",
    bookingType: "past",
    fareLocked: false
  },
  {
    bookingCategory: "multiCity",
    bookingType: "past",
    fareLocked: false
  }
];
